import theme from '@styles/theme';
const parseBreakpointPx = (value: string) => parseInt(value.replace('px', ''), 10);

/** Progi `min-width` dla `<picture>` w ImageSource — zgodne z `getCurrentDevice` (tablet od [1], desktop od [3]). */
export function getPictureMediaMinWidthsPx(): {
  tablet: number;
  desktop: number;
} {
  const b = theme.breakpoints.map(parseBreakpointPx);
  return {
    tablet: b[1],
    desktop: b[3]
  };
}